import {get, merge, sumBy} from 'lodash';
import moment from 'moment';
import {columnsFn, inlineSchema} from './utils';
import i18n from '../i18n/index';
import * as Appointment from './appointment';
import * as utils from './utils';
import * as Member from './membership';
import debug from '../debug';

export function title(model) {
  return model
    ? `${moment(get(model, 'created_at')).format('YYYY-MM-DD HH:mm:ss')} (${Member.title.call(this, get(model, 'refs.sender'))} to ${Member.title.call(this, get(model, 'refs.receiver'))})`
    : i18n.s('schema.appointment');
}

export const columns = columnsFn(function () {
  return {
    feedback_id: {type: 'id'},
    status: {type: 'select', items: ['status.active', 'status.inactive'], default: 'active'}, //  active / deleted
    created_at: {type: 'datetime', readonly: true},
    type: {
      type: 'select',
      items: [
        'type.feedback.admin_to_caregiver',
        'type.feedback.admin_to_client',
        'type.feedback.client_to_caregiver',
        'type.feedback.client_appointment_feedback',
      ],
      readonly: true,
    },
    tags: {type: 'tags'},

    details: {
      type: 'schema',
      schema: inlineSchema({
        remark: {type: 'label'},
        scores: {
          type: 'array', itemType: {
            type: 'schema', schema: merge(inlineSchema({
              question: {type: 'label'},
              score: {type: 'label'},
              weight: {type: 'label', label: i18n.fr('fields.ratio')},
            }), {
              title(model) {
                return i18n.nn`${model.question} : ${model.score}`;
              },
            }),
          },
        },
        avg_score: {
          type: 'label',
          readonly: true, get(model) {
            try {
              return model && model.scores
                ? Math.round(sumBy(model.scores, x => x.score * Number(x.weight)) / sumBy(model.scores, x => Number(x.weight)) * 10) / 10
                : 0;
            } catch (e) {
              return NaN;
            }
          },
        },
      }),
    },
    'refs.sender': {type: 'schema', schema: Member, readonly: true, list: true},
    'refs.receiver': {type: 'schema', schema: Member, readonly: true, list: true},
    'refs.appointment': {type: 'schema', schema: Appointment, readonly: true},
  };
});
export const list = utils.listFn('getFeedbacks', function (payload) {
  payload.type = 'caregiver_appointment_feedback';
  return payload;
});

export function view(model, index, schema, columns) {
  return utils.viewFn(model && model.type === 'client_to_caregiver'
    ? '/admin/feedback-client/:id'
    : '/admin/feedback-caregiver/:id').apply(this, arguments);
}

export const read = utils.readFn('getFeedbackById', 'feedback_id');

export function formActions(model, schema, readonly) {
  let temp = [];
  if (debug.DEBUG) {
    temp.push({
      label: i18n.fr('action.delete') + ' [Del]',
      class: 'btn-danger',
      trigger: e => e.keyCode === 46,
      action: utils.formActions.delete(
        'deleteFeedbackById',
        'feedback_id',
        '/admin/feedback-caregiver'),
    });
  }
  temp.push(utils.formActions.back);
  return temp;
}



// WEBPACK FOOTER //
// ./src/schemas/feedback-caregiver.js